


















import { Component, Vue, Watch } from 'vue-property-decorator';
import { observeUser, renderAuthUI, signOut } from '@/firebaseApp';
import * as firebase from 'firebase';
import Roles from '@/services/Roles';

@Component
export default class Login extends Vue {
  public user: firebase.User | null = null;
  public loading = true;

  created() {
    observeUser(async user => {
      this.user = user;
      if (user) {
        await this.redirectUser();
      }
      this.loading = false;
    });
  }

  @Watch('loading')
  onLoadingChange() {
    if (!this.loading) {
      Vue.nextTick(() => {
        this.renderLogin();
      });
    }
  }

  renderLogin() {
    const ref = this.$refs['firebaseui-auth-container'] as HTMLElement;
    renderAuthUI(ref);
  }

  async redirectUser() {
    if (await Roles.isAdmin()) {
      this.$router.replace({ name: 'Admin' });
      return;
    } else if (await Roles.isTeacher()) {
      this.$router.replace({ name: 'TeacherModules' });
      return;
    }
  }

  async signOutUser() {
    await signOut();
    this.user = null;
    this.renderLogin();
  }

  get year() {
    return new Date().getFullYear();
  }
}
